import { withConfig } from "@/utils/withConfig";
import { DisplayAmount } from "./DisplayAmount";

export * from "./DisplayAmount";

export const DisplayAmountWithConfig = withConfig(DisplayAmount, "amount");
